import React, { useState } from "react";
import getBasePrice from "../../../util/getBasePrice";
import { AddonObj } from "../../../util/quoteCartStorage";

function useItemizedCostsSelector(
  data: AddonObj[],
  quantity: number,
  unitPrice: string
) {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.ChangeEvent<any>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const basePrice = getBasePrice({
    itemizedCosts: data,
    unitPrice,
    qty: quantity,
  });

  return {
    basePrice,
    handleClick,
    handleClose,
    open,
    anchorEl,
  };
}

export default useItemizedCostsSelector;
